import { Modal } from "@pacificoseguros/pixie/react/modal";
import React, { memo } from "react";
import icHelpDesk from "../../assets/icons/ic-help-desk.svg";
import { Column } from "../../components/layout/flex-layout";
import { SizedBox } from "../../components/layout/sized-box";
import { SpacingBox } from "../../components/layout/spacing-box";
import { Typography } from "../../components/typography/typography";
import { DatalayerModal } from "../../libs/datalayer/components/datalayer-modal";
import { DatalayerModalPixieButton } from "../../libs/datalayer/components/datalayer-modal-pixie-button";
import { useCannotOfferThisProductPopup } from "./hooks/use-cannot-offer-this-product-popup";

const CannotOfferThisProductPopup = () => {
    const { opened, close } = useCannotOfferThisProductPopup();
    return (
        opened && (
            <DatalayerModal
                open={opened}
                onClose={close}
                as={Modal}
                type="Error"
                name="No podemos ofrecerte este producto"
                data-testid="cannot-offer-this-product-popup"
            >
                <SpacingBox pt={30} pb={10}>
                    <Typography textAlign="center" as="div" fontSize={16}>
                        <SizedBox width={280}>
                            <Column align="center">
                                <img src={icHelpDesk} alt="error generico" />
                            </Column>
                            <SpacingBox mb={27} />
                            <Typography fontSize={20}>
                                <b>¡Hola!</b>
                            </Typography>
                            <SpacingBox mb={17} />
                            <div>
                                Por este medio no podemos ofrecerte<br></br>
                                este producto. Para mayor<br></br>
                                información, agradeceremos puedas<br></br>
                                comunicarte con el siguiente número.
                            </div>
                            <SpacingBox mb={26} />
                            <a href="tel:015135000">
                                <Typography
                                    variant="secondary"
                                    decoration="underline"
                                    fontSize={24}
                                >
                                    01 513 5000
                                </Typography>
                            </a>
                            <SpacingBox mb={26} />
                            <DatalayerModalPixieButton
                                kind="secondary"
                                inverse
                                fluid
                                onClick={close}
                                label="Volver"
                            >
                                Volver
                            </DatalayerModalPixieButton>
                        </SizedBox>
                    </Typography>
                </SpacingBox>
            </DatalayerModal>
        )
    );
};

export default memo(CannotOfferThisProductPopup);
